<template>
  <form @submit.prevent="login">
    <div class="form-group">
      <label for="email">Username:</label>
      <input id="email"
             v-model="formData.email"
             name="email" required type="text"/>
    </div>
    <div class="form-group">
      <label for="password">Password:</label>
      <input
          id="password" v-model="formData.password" name="password" required type="password"/>
    </div>
    <button>Login</button>
  </form>
</template>
<script lang="ts" setup>
import {ref} from "vue";

defineOptions({
  name: 'LoginForm',
})

const formData = ref({
  email: '',
  password: ''
})

const login = async () => {
  try {
    const response = await fetch('/authent/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData.value)
    });
    if (!response.ok)
      throw new Error(response.statusText);

    const data = await response.json();
    console.log('Login successful:', data);
    // await router.push('/dashboard');
    window.location.href = '/dashboard';

  } catch (error) {
    console.error('Login failed:', error);
  }

}
</script>
<style scoped>

html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>